import { RetrofitStatus, useRetrofitCheck } from 'src/Libs/retrofit'
import { useRetrofitList } from 'src/Libs/retrofit/hooks/use-retrofit-list'

interface UseRetrofitBanner {
  showRetrofitBanner: boolean
  retrofitTargetSystem: string | undefined
}

/**
 * Hook to determine if the retrofit banner should be shown inside the dashboard or not
 *
 * @param installationId - active installaltion ID
 * @param storageId - active Storage Id
 */
export const useRetrofitBanner = (installationId?: string, storageId?: string): UseRetrofitBanner => {
  const { retrofitTarget: retrofitListTarget, isRetrofitBannerHidden, retrofitList } = useRetrofitList(installationId, storageId)
  const { retrofitData } = useRetrofitCheck(storageId)

  const showRetrofitBannerForFarmMaster = !isRetrofitBannerHidden && retrofitList.length > 0
  const showRetrofitBannerForClient = !isRetrofitBannerHidden && retrofitData && retrofitData.status === RetrofitStatus.ok

  const showRetrofitBanner = !!installationId && !!storageId && (showRetrofitBannerForFarmMaster || showRetrofitBannerForClient)

  const retrofitTarget = retrofitListTarget ?? retrofitData?.system?.serialnumber?.toString()

  return {
    showRetrofitBanner: showRetrofitBanner ?? false,
    retrofitTargetSystem: retrofitTarget,
  }
}
